import { useMemo } from 'react'
import { ObjectiveRecord } from '@/api/models/objectiveRecord'

export function useIsMigratedCourse(lastObjectiveRecord?: ObjectiveRecord | null) {
  return useMemo(() => {
    return Boolean(lastObjectiveRecord && lastObjectiveRecord.objectiveWorkflowId === null)
  }, [lastObjectiveRecord])
}
